module.exports = __webpack_public_path__ + "media/fonts/Oricons-bd4009169d9cd026640659f260f82964.eot";